import React from "react";
import greenBlob from "../../assets/images/green-blur.webp";
import Button from "../common/Button";
import completedGif from "../../assets/gifs/completed.webp";

type CompletedEventBoxProps = {
  imagePath?: string;
  title?: string;
  text?: string;
  date?: string;
  onClick?: () => void;
};

const CompletedEventBox: React.FC<CompletedEventBoxProps> = ({
  imagePath,
  title,
  text,
  date,
  onClick,
}) => {
  const cardBackgroundImage = greenBlob;

  return (
    <div
      className="completed-event-card card text-white border border-2 mx-auto shadow-lg position-relative overflow-hidden"
      style={{
        maxWidth: "22rem",
        minHeight: "38rem",
        borderColor: "#26ff89",
        borderRadius: "1.5rem",
        boxShadow: "inset 0 0 20px rgba(38, 255, 137, 0.6)",
        fontFamily: "Inter, sans-serif",
        background: "radial-gradient(circle at center, #001a0f, #000000)",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
      }}
    >
      <img
        src={cardBackgroundImage}
        alt="Background"
        loading="lazy"
        className="position-absolute top-50 start-50 translate-middle"
        style={{
          width: "80%",
          height: "80%",
          objectFit: "contain",
          filter: "blur(10px)",
          zIndex: 0,
          pointerEvents: "none",
        }}
        onError={(e: any) => {
          e.target.onerror = null;
          e.target.src =
            "https://placehold.co/600x400/004d1a/FFFFFF/blur?text=Error+BG";
        }}
      />

      <img
        src={completedGif}
        loading="lazy"
        alt="Completed"
        className="position-absolute"
        style={{
          top: "15px",
          left: "15px",
          height: "80px",
          width: "auto",
          objectFit: "contain",
          zIndex: 10,
        }}
        onError={(e: any) => {
          e.target.onerror = null;
          e.target.src =
            "https://placehold.co/100x40/00ff00/000000?text=DONE";
        }}
      />

      <div
        className="card-body position-relative d-flex flex-column"
        style={{ zIndex: 2, marginTop: "2rem" }}
      >

        <div
          className="mb-3 rounded overflow-hidden"
          style={{
            height: "14rem",
            backdropFilter: "blur(8px)",
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={imagePath}
            alt={title}
            loading="lazy"
            className="w-100 h-100"
            style={{ objectFit: "contain" }}
            onError={(e: any) => {
              e.target.onerror = null;
              e.target.src =
                "https://placehold.co/400x200/cccccc/000000?text=Image+Error";
            }}
          />
        </div>

        <h5 className="card-title fs-4 mb-2">{title}</h5>
        <p className="card-text small mb-3 text-white-50">{text}</p>

        <div className="d-flex justify-content-between align-items-center text-white-50 mb-4">
          <div>
            <span role="img" aria-label="calendar" className="me-2">
              🗓️
            </span>
            {date}
          </div>
          <div className="text-success fw-semibold d-flex align-items-center">
            <span className="me-1 fs-5 animate__animated animate__pulse animate__infinite">
              🟢
            </span>
            Completed
          </div>
        </div>

        <Button
          text="View Recap"
          gradient="linear-gradient(to right, #0a3f2e, #26ff89)"
          onClick={onClick}
        />
      </div>

      <style>{`
          .completed-event-card:hover {
            transform: scale(1.02);
            box-shadow: 0 12px 40px rgba(38, 255, 137, 0.5);
          }
        `}</style>
    </div>
  );
};

export default CompletedEventBox;
